import axios from "axios";
import { async } from "q";
import { defaultValue, IProblem } from "../shared/model/problem.model";
import { ICrudPutAction } from "../shared/type/redux-action.type";
import { FAILURE, REQUEST, SUCCESS } from "./actionType.util";

// TYPES
export const ACTION_TYPES = {
  CREATE_PROBLEM: "application/CREATE_PROBLEM",
  RESET: "application/RESET",
};

const initialState = {
  loading: false,
  errorMessage: null,
  entity: null,
  updating: false,
  updateSuccess: false,
};

export type ProblemState = Readonly<typeof initialState>;

// RECUCER

export const problemReducer = (
  state: ProblemState = initialState,
  action: any
) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.CREATE_PROBLEM):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
        loading: true,
      };
    case FAILURE(ACTION_TYPES.CREATE_PROBLEM):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.CREATE_PROBLEM):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

// ACTIONS
const apiUrl = "/api/ksds/portal-external/mail/send/helpdesk";
export const sendProblemMail = (entity: IProblem) => {
  return {
    type: ACTION_TYPES.CREATE_PROBLEM,
    payload: axios.post(apiUrl, entity),
  };
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
